import(/* webpackMode: "eager" */ "/vercel/path0/src/app/politicas/calidad/page.tsx");
